export { pageTransition, pageVariants, animatePresenceVariants } from './animations.common';
export const mobileHeaderVariants = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1,
        transition: {
            duration: 0.4,
            ease: 'easeInOut',
            delay: 0.3
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0.2,
            ease: 'easeInOut'
        }
    }
};
export const mobileTitleVariants = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1,
        transition: {
            duration: 0.4,
            ease: 'easeInOut',
            delay: 0.3
        }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0.2,
            ease: 'easeInOut'
        }
    }
};
export const mobileFooterVariants = {
    initial: {
        y: 100,
        opacity: 0
    },
    animate: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 0.4,
            ease: 'easeInOut',
            delay: 1
        }
    },
    exit: {
        y: 100,
        opacity: 0,
        transition: {
            duration: 0.3,
            ease: 'easeInOut'
        }
    }
};
